
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return 939 != chunkId;
},
rootOutputDir: "",

    };
}
